import React from 'react';
import {
  VKShareButton,
  TwitterShareButton,
} from 'react-share';

import styles from './assets/styles/styles.module.scss'

import { ReactComponent as IconTimer } from './assets/icons/result-time-icon.svg';
import { ReactComponent as IconBrain } from './assets/icons/result-brain-icon.svg';
import { ReactComponent as IconRestartTest } from '~/assets/icons/restart-test-icon.svg';
import { ReactComponent as VkShareIcon }  from '~/assets/icons/vk-share-icon.svg';
import { ReactComponent as TwitterShareIcon }  from '~/assets/icons/twitter-share-icon.svg';

import AGE_DATA, { RESULT_TEXT } from '~/constants/read_const';

class ResultComponent extends React.Component {
  constructor(props) {
    super(props);
    this.mainRef = React.createRef();
  }

  async componentDidMount() {
    await this.mainRef.current.scrollIntoView();
    document.documentElement.scrollTop -= 180;
    /* eslint no-undef: off */
    if (typeof $ !== 'undefined') {
      $(document).trigger('initPopup');
    }
  }

  getGoodEditedTitle(title, replacement) {
    return title.replace('%%', replacement);
  }

  render() {
    const {
      name,
      wordsPerMinute,
      understandingPercentage,
      signsCount,
      time: {
        hours,
        minutes,
        seconds
      },
      ageCategory,
      restartTestHandler
    } = this.props;

    const {
      goodResultTitle,
      decentResultTitle,
      yourResultText,
      wordsPerMinuteText,
      understoodPercentageText,
      signsInText,
      readingTimeText,
      ageCategoryText,
      assumingTitle,
      assumingDescription,
      submitFreeLessonText,
      shareResultText,
      tellFriendsText,
      hoursText,
      minutesText,
      secondsText,
      restartTest,
      shareGoodTitleText,
      shareDecentTitleText,
      shareGoodDescriptionText,
      shareDecentDescriptionText
    } = RESULT_TEXT;

    const goodResult = understandingPercentage === 1 && wordsPerMinute >= 200;
    return (
      <div className={styles.result} ref={this.mainRef}>
        <div className={styles.container}>
          <h1 className={styles.title}>{goodResult ? goodResultTitle : decentResultTitle}</h1>
          <div className={styles['tests-result']}>
            <div className={styles['tests-result-item']}>
              <IconTimer />
              <div className={styles['tests-result-text']}>
                <span className={styles['tests-result-caption']}>{yourResultText}</span>
                <span className={styles['tests-result-description']}>{`${wordsPerMinute} ${wordsPerMinuteText}`}</span>
              </div>
            </div>
            <div className={styles['tests-result-item']}>
              <IconBrain />
              <div className={styles['tests-result-text']}>
                <span className={styles['tests-result-caption']}>{understoodPercentageText}</span>
                <span className={styles['tests-result-description']}>{`${Math.floor(understandingPercentage * 100)}%`}</span>
              </div>
            </div>
          </div>
          <div className={styles['tests-information']}>
            <h2 className={styles['persons-name']}>{name || RESULT_TEXT.noNameEntered}</h2>
            <div className={styles['text-information']}>
              <div className={styles['text-information-block']}>
                <div className={styles['text-information-container']}>
                  <span className={styles['text-information-title']}>{signsInText}</span>
                  <span className={styles['text-information-description']}>{signsCount}</span>
                </div>
              </div>
              <div className={styles['text-information-block']}>
                <div className={styles['text-information-container']}>
                  <span className={styles['text-information-title']}>{readingTimeText}</span>
                  <span className={styles['text-information-description']}>{`
                    ${hours !== 0 ? `${hours} ${hoursText} ` : ''}
                    ${minutes !== 0 ? `${minutes} ${minutesText} ` : ''}
                    ${seconds !== 0 ? `${seconds} ${secondsText}` : ''}
                  `}</span>
                </div>
              </div>
              <div className={styles['text-information-block']}>
                <div className={styles['text-information-container']}>
                  <span className={styles['text-information-title']}>{ageCategoryText}</span>
                  <span className={styles['text-information-description']}>{AGE_DATA[ageCategory - 1].text}</span>
                </div>
              </div>
            </div>
          </div>
          <h1 className={styles['assume-title']}>{assumingTitle}</h1>
          <p className={styles['assume-description']}>{assumingDescription}</p>
          <div className={styles['interraction-block']}>
            <a className={`${styles['get-freelesson-button']} iq-tests-button js-popup`} href="/popup/schedule-a-lesson">
              {submitFreeLessonText}
            </a>
            {!goodResult && (
              <button className={styles['restart-test-button']} onClick={restartTestHandler}>
                <span className={styles['restart-test-text']}>{restartTest}</span>
                <IconRestartTest className={styles['restart-test-icon']} />
              </button>
            )}
          </div>
          <div className={styles['share-result-container']}>
            <span className={styles['share-result-text']}>{goodResult ? shareResultText : tellFriendsText}</span>
            <div className={styles['share-icons-container']}>
              <VKShareButton
                className={styles['share-custom-button']}
                url='https://iq007.ru/tests/read'
                title={goodResult ?
                  this.getGoodEditedTitle(shareGoodTitleText, wordsPerMinute) :
                  shareDecentTitleText
                }
                description={goodResult ?
                  shareGoodDescriptionText :
                  shareDecentDescriptionText
                }
              >
                <VkShareIcon />
              </VKShareButton>
              <TwitterShareButton
                className={styles['share-custom-button']}
                url='https://iq007.ru/tests/read'
                title={goodResult ?
                  this.getGoodEditedTitle(shareGoodTitleText, wordsPerMinute) :
                  shareDecentTitleText
                }
                via={goodResult ?
                  shareGoodDescriptionText :
                  shareDecentDescriptionText
                }
              >
                <TwitterShareIcon />
              </TwitterShareButton>
            </div>
          </div>
        </div>
        <div className={styles['white-circle']} />
        <div className={styles['fox-image']} />
      </div>
    );
  }
}

export default ResultComponent;
